"use client";

import React from "react";
import { BlurFade } from "@/components/ui/blur-fade";

interface TocItem {
  label: string;
  href: string;
}

interface TableOfContentsProps {
  items?: TocItem[];
  breadcrumbs?: TocItem[];
}

const TableOfContents = ({ items, breadcrumbs }: TableOfContentsProps) => {
  const tocItems = items || breadcrumbs || [];
  if (tocItems.length === 0) return null;

  return (
    <section className="py-4 px-6 bg-white sticky top-0 z-40 border-b border-foreground/5">
      <div className="container max-w-5xl mx-auto">
        <BlurFade delay={0.1}>
          <nav className="overflow-x-auto scrollbar-hide">
            <ul className="flex items-center gap-2 min-w-max py-1">
              {tocItems.map((item, i) => (
                <li key={i}>
                  <a
                    href={item.href}
                    className="inline-block px-4 py-2 text-sm font-medium text-foreground/60 hover:text-foreground bg-muted/50 hover:bg-muted rounded-full transition-colors whitespace-nowrap"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </BlurFade>
      </div>
    </section>
  );
};

export default TableOfContents;
